import Types from "./types";
import { CarService } from "../../../service/car-service";

const setUserPhoneNumber = (userPhoneNumber) => ({
    type: Types.SET_USER_PHONE_NUMBER,
    userPhoneNumber
});

const activateReferral = () => ({
    type: Types.ACTIVATE_REFERRAL
});

const activateReferralSuccess = details => ({
    type: Types.ACTIVATE_REFERRAL_SUCCESS,
    details
});

const activateReferralFailure = error => ({
    type: Types.ACTIVATE_REFERRAL_ERROR,
    error
});

const fetchReferralCode = (mobile) => dispatch => {
    dispatch(activateReferral());
    return new Promise((resolve, reject) => {
        CarService.fetchReferralCode(mobile)
            .then(response => {
                const referralDetails = (((response || {}).data || {}).detail || {});
                dispatch(activateReferralSuccess(referralDetails));
                resolve(referralDetails);
            })
            .catch(error => {
                dispatch(activateReferralFailure(error));
                reject(error);
            });
    });

};

export {
    setUserPhoneNumber,
    activateReferral,
    fetchReferralCode,
    activateReferralSuccess
};
